/**
 * Маппер профиля из формата Supabase (snake_case) в доменный тип User
 */

import type { User } from '../model';
import type { Database } from '@/lib';

/** Строка из таблицы profiles */
type ProfileRow = Database['public']['Tables']['profiles']['Row'];

/**
 * Маппинг строки profiles из БД в доменный тип User
 *
 * @param row — строка из таблицы profiles (snake_case)
 * @param email — email берётся из auth.users, не из profiles
 */
export function mapProfileRowToUser(row: ProfileRow, email?: string): User {
  return {
    id: row.id,
    email,
    name: row.display_name || '',
    lastName: row.last_name || '',
    username: row.username || '',
    avatarUrl: row.avatar_url ?? undefined,
    birthDate: row.birth_date ?? undefined,
    createdAt: row.created_at,
  };
}